import React from "react";
import { usePagination } from "react-instantsearch";
import { buildPaginationPages } from "./utils";

const defaultHideMobile = () => false;

export default function AlgoliaPagination({
  onScroll,
  className = "",
  withEdgeClass = false,
  hideMobilePredicate = defaultHideMobile,
}) {
  const { refine, currentRefinement, nbPages, isFirstPage, isLastPage } =
    usePagination({ padding: 1 });

  if (!nbPages || nbPages <= 1) return null;

  const current = currentRefinement + 1;
  const pages = buildPaginationPages(current, nbPages);

  const itemClassName = (page) => {
    const classes = ["c-pagination__item"];
    if (withEdgeClass && (page === 1 || page === nbPages)) {
      classes.push("c-pagination__item--edge");
    }
    if (current === page) {
      classes.push("c-pagination__item--active");
    }
    if (hideMobilePredicate(page, current, nbPages)) {
      classes.push("c-pagination__item--hide-mobile");
    }
    return classes.join(" ");
  };

  const containerClass = ["c-pagination", className].filter(Boolean).join(" ");

  return (
    <div className={containerClass}>
      <button
        type="button"
        className="c-pagination__button c-pagination__button--arrow"
        onClick={() => {
          refine(currentRefinement - 1);
          onScroll?.();
        }}
        disabled={isFirstPage}
        aria-label="Previous page"
      >
        <svg
          className="c-pagination__arrow"
          aria-hidden="true"
          width="14"
          height="14"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.5 3.5 5 8l4.5 4.5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span className="c-pagination__label">Previous</span>
      </button>
      <ul className="c-pagination__list">
        {pages.map((page, idx) =>
          page === "ellipsis" ? (
            <li key={`ellipsis-${idx}`} className="c-pagination__ellipsis" aria-hidden="true">
              …
            </li>
          ) : (
            <li key={page} className={itemClassName(page)}>
              <button
                type="button"
                className={`c-pagination__button${current === page ? " c-pagination__button--active" : ""}`}
                onClick={() => {
                  refine(page - 1);
                  onScroll?.();
                }}
                aria-current={current === page ? "page" : undefined}
              >
                {page}
              </button>
            </li>
          )
        )}
      </ul>
      <button
        type="button"
        className="c-pagination__button c-pagination__button--arrow"
        onClick={() => {
          refine(currentRefinement + 1);
          onScroll?.();
        }}
        disabled={isLastPage}
        aria-label="Next page"
      >
        <svg
          className="c-pagination__arrow"
          aria-hidden="true"
          width="14"
          height="14"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="m6.5 3.5 4.5 4.5-4.5 4.5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span className="c-pagination__label">Next</span>
      </button>
    </div>
  );
}
